import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from '../pages/Landing';
import Dashboard from '../pages/Dashboard';
import Resources from '../pages/Resources';
import About from '../pages/About';
import Journal from '../pages/Journal';
import Settings from '../pages/Settings';
import AuthPage from '../pages/AuthPage';
import AuthCallback from '../pages/AuthCallback';
import Admin from '../pages/Admin';
import TermsConditions from '../pages/TermsConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Screener from '../pages/Screener';
import News from '../pages/News';
import ProAccess from '../pages/ProAccess';
import ChartAnalyzer from '../pages/ChartAnalyzer';
import Research from '../pages/Research';
import Alerts from '../pages/Alerts';
import Paper from '../pages/Paper';
import Backtest from '../pages/Backtest';
import Intel from '../pages/Intel';
import Marketplace from '../pages/Marketplace';
import StrategyShare from '../pages/StrategyShare';
import Ebooks from '../pages/Ebooks';
import Community from '../pages/Community';
import Courses from '../pages/Courses';
import CourseDetail from '../pages/CourseDetail';
import SharedCoursePage from '../pages/SharedCoursePage';
import ProGate from '../components/ProGate';
import { PRO_FEATURES } from '../config/proFeatures';

const Gated = ({ path, children }) => {
  const cfg = PRO_FEATURES[path];
  return (
    <ProGate feature={cfg.feature} description={cfg.description}>
      {children}
    </ProGate>
  );
};

/**
 * Centralized route table. Extracted from App.js so the top-level shell stays
 * focused on providers/layout. Pro-gate copy lives in `/config/proFeatures.js`
 * and is applied here via the small <Gated /> wrapper.
 */
const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Landing />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/resources" element={<Resources />} />
    <Route path="/journal" element={<Gated path="/journal"><Journal /></Gated>} />
    <Route path="/settings" element={<Settings />} />
    <Route path="/about" element={<About />} />
    <Route path="/auth" element={<AuthPage />} />
    <Route path="/auth/callback" element={<AuthCallback />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="/terms" element={<TermsConditions />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/screener" element={<Gated path="/screener"><Screener /></Gated>} />
    <Route path="/news" element={<News />} />
    <Route path="/pro-access" element={<ProAccess />} />
    <Route path="/pricing" element={<Navigate to="/pro-access" replace />} />
    <Route path="/research" element={<Gated path="/research"><Research /></Gated>} />
    <Route path="/chart-analyzer" element={<Gated path="/chart-analyzer"><ChartAnalyzer /></Gated>} />
    <Route path="/alerts" element={<Gated path="/alerts"><Alerts /></Gated>} />
    <Route path="/paper" element={<Paper />} />
    <Route path="/backtest" element={<Gated path="/backtest"><Backtest /></Gated>} />
    <Route path="/intel" element={<Intel />} />
    <Route path="/marketplace" element={<Gated path="/marketplace"><Marketplace /></Gated>} />
    <Route path="/s/:strategyId" element={<StrategyShare />} />
    <Route path="/ebooks" element={<Ebooks />} />
    <Route path="/community" element={<Gated path="/community"><Community /></Gated>} />
    <Route path="/courses" element={<Gated path="/courses"><Courses /></Gated>} />
    <Route path="/courses/:courseId" element={<Gated path="/courses"><CourseDetail /></Gated>} />
    <Route path="/share/courses/:token" element={<SharedCoursePage />} />
  </Routes>
);

export default AppRoutes;
